// 企业合作
<template>
    <div class="cooperation">
        <div class="one1">
            <div class="one1Content">
                <div class="topContent">
                </div>
                <div class="cooperaTitle">
                    <div class="left">
                        <span class="left1"></span>
                        <span class="left2"></span>
                        <span class="left3"></span>
                    </div>
                    <div class="name">合作伙伴</div>
                    <div class="right">
                        <span class="right1"></span>
                        <span class="right2"></span>
                        <span class="right3"></span>
                    </div>
                </div>
                <transition-group appear tag="div" class="bottomContent" name="groupListLeft">
                    <div class="item" v-for="(item,index) in companyList" :key="index">
                        <img :src="item.img" alt="">
                    </div>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: '',
  props: {
    
  },
  data(){
      return{
            companyList:[
                {
                    time:0.2,
                    img:require('@/assets/icon/company/1.png'),
                },{
                    time:0.4,
                    img:require('@/assets/icon/company/2.png'),
                },{
                    time:0.6,
                    img:require('@/assets/icon/company/3.png'),
                },{
                    time:0.8,
                    img:require('@/assets/icon/company/4.png'),
                },{
                    time:1.0,
                    img:require('@/assets/icon/company/5.png'),
                },{
                    time:1.2,
                    img:require('@/assets/icon/company/6.png'),
                },{
                    time:1.4,
                    img:require('@/assets/icon/company/7.png'),
                },{
                    time:1.6,
                    img:require('@/assets/icon/company/8.png'),
                },{
                    time:1.8,
                    img:require('@/assets/icon/company/9.png'),
                },{
                    time:2.0,
                    img:require('@/assets/icon/company/10.png'),
                },{
                    time:2.2,
                    img:require('@/assets/icon/company/11.png'),
                },{
                    time:2.4,
                    img:require('@/assets/icon/company/12.png'),
                },{
                    time:2.6,
                    img:require('@/assets/icon/company/13.png'),
                },{
                    time:2.8,
                    img:require('@/assets/icon/company/14.png'),
                },{
                    time:3.0,
                    img:require('@/assets/icon/company/15.png'),
                },{
                    time:3.2,
                    img:require('@/assets/icon/company/16.png'),
                },
            ]
      }
  }
}
</script>

<style scoped lang="scss">
    .home1{width: 100%;}
    
    .one1{
        width: 100%;background: url(../../../public/images/qw.jpg) no-repeat center center;background-size: cover;background-repeat:no-repeat;background-attachment:fixed;
        display: flex;flex-direction: column;justify-content: center;}
    .one1Content{max-width: 120rem;margin: 4rem auto;}
    .topContent{display: flex;flex-wrap: nowrap;align-self: baseline;justify-content: center;margin-bottom: 2rem;}
    .topContent .left{padding-right: 1rem;position: relative;}
    .onTrial{position: absolute;top: 0;right: 3rem;color: white;background: #3A6DF3;border: 0.1rem solid #fff;border-radius: 0.3rem;padding: .6rem 1.2rem;letter-spacing:0.1rem;}
    .onTrial:hover{background: #2F3F67;cursor: pointer;}
    .topContent .right{border-left: 0.1rem solid #fff;padding-left: 1rem;}
    .topContent .right .text{font-weight: 500;color: #fff;font-size: 30px;line-height: 6rem;letter-spacing:0.2rem;}


    .cooperaTitle{display: flex;justify-content: center;margin: 4rem 0;}
    .cooperaTitle .name{font-size: 26px;letter-spacing:0.2rem;color: white;}
    .cooperaTitle .left{display: flex;flex-direction: column;justify-content: flex-end;align-items: flex-end;padding-right: 1rem;}
    .cooperaTitle .left .left1{height: 2px;width: 1rem; background: rgba(255, 255, 255, 0.6);margin-bottom: .3rem;}
    .cooperaTitle .left .left2{height: 2px;width: 2rem; background: rgba(255, 255, 255, 0.6);margin-bottom: .3rem;}
    .cooperaTitle .left .left3{height: 2px;width: 3rem; background: rgba(255, 255, 255, 0.6);margin-bottom: .5rem;}
    .cooperaTitle .right{display: flex;flex-direction: column;justify-content: flex-end;align-items: flex-start;padding-left: 1rem;}
    .cooperaTitle .right .right1{height: 2px;width: 1rem; background: rgba(255, 255, 255, 0.6);margin-bottom: .3rem;}
    .cooperaTitle .right .right2{height: 2px;width: 2rem; background: rgba(255, 255, 255, 0.6);margin-bottom: .3rem;}
    .cooperaTitle .right .right3{height: 2px;width: 3rem; background: rgba(255, 255, 255, 0.6);margin-bottom: .5rem;}

    .bottomContent{display: flex;flex-wrap: wrap;justify-content: center;}
    .bottomContent .item{background: rgba(255, 255, 255, 0.7);border-radius: 10px;width: calc(27rem - 1rem);height: 17rem;margin:0 .5rem 1rem .5rem;display: flex;align-items: center;justify-content: center;
        >img{height: 6rem;}
    }
    .bottomContent .item:hover{transform: scale(1.06);cursor: pointer;}
</style>
